// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availableTime {
  padding: 35px 0 0;
}

.answerOptions {
  margin: 20px 0;
}

  .answerOptions .col-md-12 {
    display: flex;
    justify-content: center;
  }

  .answerOptions .custom-control-label {
    display: inline-block;
    padding-left: 10px;
    vertical-align: middle;
  }

.availableTime .greenBtnBig {
  max-width: 100%;
  width: auto;
}

.optionsWrap {
  max-width: 400px;
  text-align: left;
}

.custom-control {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  width: auto;
}

.custom-control-input {
  margin-top: 0;
  position: static;
  margin-right: 8px;
}

.custom-control-label {
  padding-left: 0 !important;
  margin-bottom: 0;
  cursor: pointer;
}

  .custom-control-label::before,
  .custom-control-label::after {
    display: none;
  }

.hiddenInput {
  opacity: 0;
  height: 0;
  padding: 0;
  border: none;
  z-index: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/participant/participant_qualify/participant_qualify.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;EAEE;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;EACxB;;AAEF;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;EAEE;;IAEE,aAAa;EACf;;AAEF;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".availableTime {\r\n  padding: 35px 0 0;\r\n}\r\n\r\n.answerOptions {\r\n  margin: 20px 0;\r\n}\r\n\r\n  .answerOptions .col-md-12 {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .answerOptions .custom-control-label {\r\n    display: inline-block;\r\n    padding-left: 10px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n.availableTime .greenBtnBig {\r\n  max-width: 100%;\r\n  width: auto;\r\n}\r\n\r\n.optionsWrap {\r\n  max-width: 400px;\r\n  text-align: left;\r\n}\r\n\r\n.custom-control {\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: auto;\r\n}\r\n\r\n.custom-control-input {\r\n  margin-top: 0;\r\n  position: static;\r\n  margin-right: 8px;\r\n}\r\n\r\n.custom-control-label {\r\n  padding-left: 0 !important;\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n  .custom-control-label::before,\r\n  .custom-control-label::after {\r\n    display: none;\r\n  }\r\n\r\n.hiddenInput {\r\n  opacity: 0;\r\n  height: 0;\r\n  padding: 0;\r\n  border: none;\r\n  z-index: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
